/** Reglas de las credenciales. Puro dominio: sin React, sin HTTP. */
export interface Credentials {
  readonly username: string;
  readonly password: string;
}

export interface CredentialsErrors {
  readonly username?: string;
  readonly password?: string;
}

const MIN_PASSWORD = 8;

export function validateCredentials(input: Credentials): CredentialsErrors {
  const errors: { username?: string; password?: string } = {};

  if (input.username.trim().length === 0) {
    errors.username = 'Ingresa tu usuario.';
  } else if (input.username.trim().length < 3) {
    errors.username = 'El usuario debe tener al menos 3 caracteres.';
  }

  if (input.password.length === 0) {
    errors.password = 'Ingresa tu contraseña.';
  } else if (input.password.length < MIN_PASSWORD) {
    errors.password = `La contraseña debe tener al menos ${String(MIN_PASSWORD)} caracteres.`;
  }

  return errors;
}

export function hasErrors(errors: CredentialsErrors): boolean {
  return Object.values(errors).some((value) => value !== undefined);
}

/** El API espera el usuario normalizado; la UI no debe preocuparse por eso. */
export function normalizeCredentials(input: Credentials): Credentials {
  return { username: input.username.trim().toLowerCase(), password: input.password };
}
